<!-- version 2021/05/20 -->
<template>
    <!-- <div class="d-flex justify-content-between l_rwd"> -->
    <div class="d-inline-flex p_relative">
        <app-label-text class="mb-0" :title="title"></app-label-text>
        <app-normal-text class="mr-3" :text="text"></app-normal-text>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            text: String
        }
    }
</script>

<style lang="sass" scoped>
.p_relative
  position: relative
label
  margin-right: 20px
.flex
  display: flex
  flex-direction: row
// .m_arrow_right
  position: absolute
  right: 10px
  top: 50%
  transform: translate(0%, -50%)

</style>
